import AdminLayout from '@/layouts/AdminLayout.vue'
import PublicLayout from '@/layouts/PublicLayout.vue'

export default [
  {
    path: '/repair-files',
    name: 'repairFiles',
    component: () => import('@/views/restricted/repair-files/RepairFileListView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: [
        'ADMIN_VIEW_REPAIR_FILE',
        'ADMIN_IMPORT_REPAIR_FILE_UPDATE_STATUS',
        'ADMIN_CLOSE_REPAIR_FILE',
        'ADMIN_DELETE_REPAIR_FILE'
      ],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/repair-files/:repairFileBoomerangId/finalization',
    name: 'repairFileFinalization',
    component: () => import('@/views/restricted/repair-files/RepairFileFinalizationView.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      hideHeader: true,
      permissions: ['ADMIN_ADD_REPAIR_FILE'],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/repair-files/:repairFileBoomerangId',
    name: 'repairFileDetail',
    component: () => import('@/views/restricted/repair-files/RepairFileDetailView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_VIEW_REPAIR_FILE'],
      hideHeader: true,
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/public/repair-file/customer-receipt',
    name: 'repairFileCustomerReceipt',
    component: () =>
      import('@/views/public-access/repair-module/RepairFileCustomerReceiptView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  },
  {
    path: '/public/repair-file/upload-additional-attachment',
    name: 'repairFileUploadAdditionalAttachment',
    component: () =>
      import('@/views/public-access/repair-module/RepairFileUploadAdditionalAttachmentView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  },
  {
    path: '/public/repairer-relaunch-response',
    name: 'repairFileRepairerRelaunchResponse',
    component: () =>
      import('@/views/public-access/repair-module/RepairFileRepairerRelaunchResponseView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  }
]
